import './App.css';
import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Alert } from 'reactstrap';
import LoginView from './views/LoginView';
import ProtectedRoute from './config/ProtectedRoute';
import HomeView from './views/HomeView';
import AddView from './views/AddView';
import EditView from './views/EditView';
import PasswordView from './views/PasswordView';
import DistributorsView from './views/DistributorsView';
import UsersView from './views/UsersView';
import UsersAddView from './views/UsersAddView';
import UsersEditView from './views/UsersEditView';
import DistributorsAddView from './views/DistributorsAddView';
import DistributorsEditView from './views/DistributorsEditView';
import CoreView from './views/CoreView';
import RoleProtectedRoute from './config/RoleProtectedRoute';
import { GLOBAL_AUTH_ERROR_STORAGE_KEY } from './services/apiClient';

function App() {
  const [globalAuthError, setGlobalAuthError] = useState(null);

  useEffect(() => {
    const rawError = localStorage.getItem(GLOBAL_AUTH_ERROR_STORAGE_KEY);
    if (!rawError) {
      return;
    }

    try {
      setGlobalAuthError(JSON.parse(rawError));
    } catch (_error) {
      setGlobalAuthError({ message: 'Se produjo un error de autenticacion.' });
    }
  }, []);

  const dismissGlobalAlert = () => {
    localStorage.removeItem(GLOBAL_AUTH_ERROR_STORAGE_KEY);
    setGlobalAuthError(null);
  };

  return (
    <BrowserRouter>
      {globalAuthError && (
        <div className="global-alert-container">
          <Alert color="warning" isOpen toggle={dismissGlobalAlert}>
            {globalAuthError.message || 'Se produjo un error de autenticacion.'}
          </Alert>
        </div>
      )}
      <Routes>
        <Route path="/" element={<LoginView />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/index" element={<HomeView />} />
          <Route path="/add" element={<AddView />} />
          <Route path="/edit" element={<EditView />} />
          <Route path="/distributors" element={<DistributorsView />} />
          <Route path="/distributors/add" element={<DistributorsAddView />} />
          <Route path="/distributors/edit/:id" element={<DistributorsEditView />} />
          <Route path="/password" element={<PasswordView />} />
          <Route path="/users" element={<UsersView />} />
          <Route path="/users/add" element={<UsersAddView />} />
          <Route path="/users/edit/:id" element={<UsersEditView />} />
          <Route element={<RoleProtectedRoute allowedRoles={['ADMIN']} />}>
          <Route path="/core" element={<CoreView />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
